export enum RouteNames {
  BigBrowse = 'bb',
  NotFound = 'notfound',
  ChangePassword = 'changePassword',
}

export type RootStackParamList = {
  [RouteNames.BigBrowse]: JourneyParameters;
  [RouteNames.NotFound]: undefined;
  [RouteNames.ChangePassword]: { token: string };
};

export type NavParamsType = RootStackParamList[RouteNames.BigBrowse];

export type JourneyType = 'brandconcession' | 'floor' | 'productset';

export type JourneyParameters = {
  journey: JourneyType;
  journeyParam?: number;
  productId?: number;
  depId?: number;
};

// TODO: This probably can be removed. Should not be actively used anymore.
export type JourneyRouteParams = {
  journey: JourneyType;
  targetId: number;
  productId?: number;
};
